import { paragraph, paragraphCss } from "@/styles/typography";
import { Link } from "gatsby";
import styled from "styled-components";

const Container = styled.div`
  padding: 22px;
  position: fixed;
  z-index: 1000;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.dustyGrey};
  color: white;
  display: flex;
  gap: 20px;
  align-items: center;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  opacity: 0;
  animation: fadeIn 0.5s forwards;
  animation-delay: 1.5s;

  @media screen and (max-width: 620px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const Paragraph = styled(paragraph)`
  font-size: 14px;
  margin: 0;
  text-align: left;
  color: ${({ theme }) => theme.colors.white};

  @media screen and (max-width: 620px) {
    text-align: center;
  }
`;

const A = styled(Link)`
  text-decoration: none;
  white-space: nowrap;
`;

const Wrapper = styled.div`
  display: flex;
  gap: 40px;
  align-items: center;

  @media screen and (max-width: 320px) {
    flex-direction: column;
    gap: 20px;
    align-items: center;
    justify-content: center;
  }
`;

const Button = styled.button`
  font-weight: 400;
  font-family: "Aeonik - Regular";

  border: none;
  color: ${({ theme }) => theme.colors.tango};
  background-color: #ffffff;
  padding: 10px 20px;
  cursor: pointer;

  transition: all 0.2s ease-in-out;

  a {
    color: ${({ theme }) => theme.colors.tango};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.tango};
    color: #ffffff;

    a {
      color: #ffffff;
    }
  }
`;

const S = {
  Container,
  Paragraph,
  A,
  Wrapper,
  Button,
};

export default S;
